define('base/class',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone");

  var Class = function() {
    if (this.initialize) { this.initialize.apply(this, arguments); }
  };
  Class.extend = Backbone.Model.extend;

  module.exports = Class;
});

